// extracted by mini-css-extract-plugin
module.exports = {"modal":"LN","modalContent":"MN","modalOverlay":"NN","copy":"ON","modalBtnContainer":"PN","btnStay":"QN","disabled":"RN","btnContinue":"SN"};